import React from 'react';

import {
  Card,
  ImageList,
  ImageListItem,
  ImageListItemBar,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

import type { PurchasePhotoType } from '../SelectPhotoType';
import type { GroupDetailController } from '../groupDetailController';

import CardMediaImage from '@/components/CardMediaImage';
import PhotoModal from '@/components/PhotoModal';

/**
 * プロパティ
 */
export type Props = {
  /** 施設ID */
  nurseryId: string,
  /** 写真リスト */
  photoList: PurchasePhotoType[],
  /** コントローラー */
  controller: GroupDetailController,
};

const Purchase: React.FC<Props> = ({ nurseryId, photoList, controller }) => {
  const [previewS3Path, setPreviewS3Path] = React.useState<string | undefined>(undefined);
  const [innerWidth, setInnerWidth] = React.useState<number>(window.innerWidth);
  const [_innerHeight, setInnerHeight] = React.useState<number>(window.innerHeight);
  React.useEffect(() => {
    const handleResize = () => {
      setInnerWidth(window.innerWidth);
      setInnerHeight(window.innerHeight);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const div = Math.floor(innerWidth / 400);
  const width = Math.round((innerWidth - 60 - div * 8) / div);
  const { totalPrice, totalPricePhotoTypes } = controller.getTotalPrices();
  return (
    <div>
      <h2>購入する写真一覧</h2>
      <div>
        <p>以下が購入写真の一覧です。</p>
        <ImageList cols={div}>
          {photoList.map((item) => {
            let title = item.photoTypes[0].type.name;
            if (item.photoTypes[0].type.photoItemId !== 'download') {
              title += `(${item.photoTypes[0].num}枚)`;
            }
            for (let i = 1; i < item.photoTypes.length; i += 1) {
              title += `, ${item.photoTypes[i].type.name}`;
              if (item.photoTypes[i].type.photoItemId !== 'download') {
                title += `(${item.photoTypes[i].num}枚)`;
              }
            }
            return (
              <ImageListItem
                key={item.id}
                style={{
                  width,
                  border: 'solid 1px #000',
                  backgroundColor: '#aaa',
                }}
              >
                <Card style={{ margin: 'auto' }}>
                  <CardMediaImage
                    nurseryId={nurseryId}
                    s3Path={`WagakoNurseryPhoto_PhotoEntity/${item.id}/thumbnail.webp`}
                    onClick={() => setPreviewS3Path(`WagakoNurseryPhoto_PhotoEntity/${item.id}/sample.webp`)}
                    alt={item.id}
                    width={width}
                    objectFit="cover"
                  />
                </Card>
                <ImageListItemBar
                  title={title}
                  subtitle={item.name}
                />
              </ImageListItem>
            );
          })}
        </ImageList>
      </div>
      <h2>支払い料金の確認</h2>
      <div>
        <TableContainer component={Paper}>
          <Table aria-label="spanning table">
            <TableHead>
              <TableRow>
                <TableCell style={{ width: '180px' }}>写真種別</TableCell>
                <TableCell style={{ width: '70px' }} align="right">料金</TableCell>
                <TableCell style={{ width: '50px' }} align="right">個数</TableCell>
                <TableCell align="right">合計</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {totalPricePhotoTypes.map((row) => (
                <TableRow key={row.photoItemId}>
                  <TableCell>{row.name}</TableCell>
                  <TableCell align="right">{`${row.price.toLocaleString()} 円`}</TableCell>
                  <TableCell align="right">{`x ${row.count}`}</TableCell>
                  <TableCell align="right">{`${(row.price * row.count).toLocaleString()} 円`}</TableCell>
                </TableRow>
              ))}
              <TableRow>
                <TableCell colSpan={3} style={{ fontWeight: 'bold', fontSize: '1.0em' }}>
                  合計金額 （税込）
                </TableCell>
                <TableCell align="right" style={{ fontWeight: 'bold', fontSize: '1.2em', width: '100px' }}>
                  {`${totalPrice.toLocaleString()} 円`}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      {previewS3Path && (
        <PhotoModal
          s3Path={previewS3Path}
          close={() => setPreviewS3Path(undefined)}
          nurseryId={nurseryId}
        />
      )}
    </div>
  );
};

export default Purchase;
